module.exports = __webpack_public_path__ + "img/startup.a5782396.svg";